document.addEventListener( 'DOMContentLoaded', function() {
	if (typeof Splide === 'undefined') {
		return;
	}

	if (!document.querySelector('.gfi-slider__splide')) {
		return;
	}

	var splide = new Splide( '.gfi-slider__splide', {
		perPage: 1,
		pagination: false,
	} );
	splide.mount();
});
